/* template */
<template><div class="page-wrapper"><div class="tab-container" v-if="(fuzzy)"><Tab :tabList="(fuzzyTabs)" :tabKey="(dateType)" @settabkey="setTabkey"/></div><Calendar :class="({visible:isExact, range:isRange, fuzzy:fuzzy })" :type="(calendar_type)" :value="(select_date)" :minDate="(minDate)" :maxDate="(maxDate)" :maxRange="(maxRange)" :subTexts="(calendarSubTexts)" @confirm="onConfirm" class="tab-content calendar"/><FuzzySelectDate :class="({visible:!isExact })" :fuzzyDate="(fuzzyDate)" @confirm="onFuzzyConfirm" class="tab-content"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mbc3924d4"}'>
.page-wrapper
  height 100vh
  background-color #fff
  .tab-container
    overflow hidden
    background-color #fff
  .tab-content
    position absolute
    visibility hidden
    z-index -1
    &.calendar
      >>> .calendar-body
        height calc(100vh - 40px)
      &.range
        >>> .calendar-body
          height calc(100vh - 160px)
      &.fuzzy
        >>> .calendar-body
          height calc(100vh - 100px)
      &.fuzzy.range
        >>> .calendar-body
          height calc(100vh - 216px)
    &.visible
      position static
      visibility visible
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mbc3924d4"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["mbc3924d4"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'FuzzySelectDate':getComponent(require("../../components/calendar-popup/fuzzy-select-date.mpx?isComponent&outputPath=components%2Ffuzzy-select-date3b2a36c7%2Findex")),'Tab':getComponent(require("../../../node_modules/@didi/spring-ui/tab/index.mpx?isComponent&outputPath=components%2Findex504b069c%2Findex")),'Calendar':getComponent(require("../../../node_modules/@didi/spring-ui/calendar/index.mpx?isComponent&outputPath=components%2Findex664bbfd5%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
